// Copyright (c) Docugami, Inc. All rights reserved.

import { DisabledCss } from 'components/common/DgCommonStyledComponents';
import styled, { css } from 'styled-components';
import { dgIconNames, useDgIcons } from '../../../hooks/dgIcons';
import { ReactNode } from 'react';

const ActiveCss = css`
    cursor: pointer;
    :hover {
        transform: scale(1.05);
        transform-origin: center;
        :active {
            transform: scale(1);
        }
    }
`

export const ButtonRoot = styled.button<{ disabled?: boolean }>`
    ${props => !props.disabled ? ActiveCss : DisabledCss};
    border: none;
    border-width: 0px;
    padding: 0px;
    background: transparent;
`

export interface DgIconButtonProps {
    id?: string;
    iconName: dgIconNames;
    height: number;
    width: number;
    color: string;
    shadow?: string;
    disabled?: boolean;
    onClick?: () => void;
    className?: string;
    background?: string;
    label?: string;
}

export const DgIconButton = (props: DgIconButtonProps): JSX.Element => {
    const dgIcons = useDgIcons();

    const icon = dgIcons.icon(
        props.iconName,
        '',
        props.height,
        props.width,
        props.color,
        props.shadow ?? '',
        props.background);

    return (
        <DgElementButton id={props.id} disabled={props.disabled} onClick={props.onClick} className={props.className}>
            {icon}{props.label ?? null}
        </DgElementButton>
    );
}

export interface DgElementButtonProps {
    id?: string;
    children?: ReactNode;
    onClick?: () => void;
    onHover?: (isHovered: boolean) => void;
    disabled?: boolean;
    className?: string;
}

export const DgElementButton = (props: DgElementButtonProps): JSX.Element => {
    return (
        <ButtonRoot
            id={props.id}
            className={props.className}
            disabled={props.disabled}
            onClick={!!props.onClick ? (ev) => {
                if (!props.disabled) {
                    ev.stopPropagation();
                    props.onClick?.();
                }
            } : undefined}
            onMouseEnter={() => props.onHover?.(true)}
            onMouseLeave={() => props.onHover?.(false)}>
            {props.children}
        </ButtonRoot>
    );
}
